var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"form-input",class:_vm.classes},[_c('input',_vm._g(_vm._b({attrs:{"type":"number"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.eventListeners))])}
var staticRenderFns = []

export { render, staticRenderFns }